export const measurePointHubPayloadBytes = (payload: unknown): number | null => {
  if (typeof TextEncoder !== 'function') return null;
  try {
    return new TextEncoder().encode(JSON.stringify(payload)).byteLength;
  } catch (_error) {
    return null;
  }
};
